const SET_SIDE_NAV = 'set_side_nav'
const SET_SIDE_NAV_FN = 'set_side_nav_fn'
const SET_MSG_INFO = 'SET_MSG_INFO'
const SET_COURSE_TREE = 'set_course_tree'
const SET_UPLOAD_FILE_LIST = 'set_upload_file_list'
const SET_PAGE_INFO = 'set_page_info'
const SET_ACTIVITY_QUERY_INFO = 'set_activity_query_info'
const SET_SELECT_COURSE = 'set_select_course'
const SET_SELECT_CLASS = 'set_select_class'
const SET_TEST_ITEM = 'set_test_item'
const SET_TEST_LIST = 'set_test_list'
const SET_RES_DETAIL = 'set_res_detail'
const SET_USER_ROLE = 'set_user_role'
const SET_SAVE_RES = 'set_save_res'

// 课后拓展 -查看
const QUERY_WORK_PARAMS = 'query_work_params';

export default{
  state:{
    sideNav:[],
    sideNavFn:{
      query:null,
      add:null
    },
    msg:{},
    course:{
      tree:'',
      treeList:[]
    },
    upload:[],
    page:{
      total: 100,
      pageSize: "10",
      pageNo: "1",
    },
    activityQuery:{
      courseId:'',
      jxclassId:'',
      time:''
    },
    selectCourse:'',
    selectClass:'',
    testItem:{
      addForm:'',
      createForm:'',
      testId:'',
    },
    workParams:{
      classid:'',
      courseid:'',
      id:'',
      name:'',
    },
    testList:{
      detail:'',
      list:[]
    },
    resDetail:'',
    userRole: '',
    saveRes: '',
  },
  mutations:{
    [SET_SIDE_NAV] (state, { nav }) {
      state.sideNav = nav
    },
    [SET_SIDE_NAV_FN] (state, { fn, type }) {
      state.sideNavFn[type] = fn
    },
    [SET_MSG_INFO] (state, { msg }) {
      state.msg = msg
    },
    [SET_COURSE_TREE] (state, { type, info }) {
      state.course[type] = info
    },
    [SET_UPLOAD_FILE_LIST] (state, { list }) {
      state.upload = list
    },
    [SET_PAGE_INFO] (state, { page }) {
      state.page = page
    },
    [SET_ACTIVITY_QUERY_INFO] (state, { activityQuery }) {
      state.activityQuery = activityQuery
    },
    [SET_SELECT_COURSE] (state, { name }) {
      state.selectCourse = name
    },
    [SET_SELECT_CLASS] (state, { name }) {
      state.selectClass = name
    },
    [SET_TEST_ITEM] (state, { item }) {
      state.testItem = item
    },
    [SET_TEST_LIST] (state, { testList }) {
      state.testList = testList
    },
    [QUERY_WORK_PARAMS](state, result){
      state.workParams = result
    },
    [SET_RES_DETAIL](state, detail){
      state.resDetail = detail
    },
    [SET_USER_ROLE](state, role){
      state.userRole = role
    },
    [SET_SAVE_RES](state, node){
      state.saveRes = node
    },
  },
  actions:{
    setSideNav({ commit, state }, {nav,cb}){
      commit(SET_SIDE_NAV, { nav })
      cb && cb()
    },
    setSideNavFn({ commit, state }, {fn, type, cb}){
      commit(SET_SIDE_NAV_FN, { fn,  type })
      cb && cb()
    },
    setMsgInfo({ commit, state }, {msg,cb}){
      commit(SET_MSG_INFO, { msg })
      cb && cb()
    },
    setCourseInfo({ commit, state }, {info, cb}){
      commit(SET_COURSE_TREE, { type:'info', info })
      cb && cb()
    },
    setCourseTree({ commit, state }, {info, cb}){
      commit(SET_COURSE_TREE, { type:'tree', info })
      cb && cb()
    },
    setCourseTreeList({ commit, state }, {info, cb}){
      commit(SET_COURSE_TREE, { type:'treeList', info })
      cb && cb()
    },    
    setCourseTreeDetail({ commit, state }, {info, cb}){
      commit(SET_COURSE_TREE, { type:'treeDetail', info })
      cb && cb()
    },
    setCourseTreeRandow({ commit, state }, {info, cb}){
      commit(SET_COURSE_TREE, { type:'randow', info })
      cb && cb()
    },
    setCourseTreeTitleChange({ commit, state }, {info, cb}){
      commit(SET_COURSE_TREE, { type:'titleChange', info })
      cb && cb()
    },
    setUploadList({ commit, state }, {list, cb}){
      commit(SET_UPLOAD_FILE_LIST, { list })
      cb && cb()
    },
    setPageInfo({ commit, state }, {page, cb}){
      commit(SET_PAGE_INFO, { page })
      cb && cb()
    },
    setActivityQuery({ commit, state }, {activityQuery, cb}){
      commit(SET_ACTIVITY_QUERY_INFO, { activityQuery })
      cb && cb()
    },
    setSelectCourse({ commit, state }, {name, cb}){
      commit(SET_SELECT_COURSE, { name })
      cb && cb()
    },
    setSelectClass({ commit, state }, {name, cb}){
      commit(SET_SELECT_CLASS, { name })
      cb && cb()
    },
    setTestItem({ commit, state }, {item, cb}){
      commit(SET_TEST_ITEM, { item })
      cb && cb()
    },
    setTestList({ commit, state }, {testList, cb}){
      commit(SET_TEST_LIST, { testList })
      cb && cb()
    },
    queryWorkParams({commit},{result,cb}){
      //console.log(result)
      commit(QUERY_WORK_PARAMS, result)
      cb && cb()
    },
    setResDetail({ commit, state }, {detail, cb}){
      commit(SET_RES_DETAIL, { detail })
      cb && cb()
    },
    clearResDetail({ commit, state }, cb){
      commit(SET_RES_DETAIL, { detail:'' })
      cb && cb()
    },
    setUserRole({ commit, state }, {role, cb}){
      commit(SET_USER_ROLE, { role })
      cb && cb()
    },
    setSaveRes({ commit, state }, {node, cb}){
      commit(SET_SAVE_RES, { node })
      cb && cb()
    },
  },
  modules:{
  }
}




// WEBPACK FOOTER //
// ./src/store/module.js